import { Layout } from "../../../layout";
import TenantsList from "../components/TenantsLists";

export function Tenants() {
  return (
    <Layout>
      <TenantsList />
    </Layout>
  );
}
